import React, { useEffect, useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { env } from '@/config/env';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import MapPage from './pages/Map';
import ArtistsPage from './pages/Artists';
import ArtistProfilePage from './pages/ArtistProfile';
import AnalyticsPage from './pages/Analytics';
import WorkflowPage from './pages/Workflow';
import PartnershipsPage from './pages/Partnerships';
import AgendaPage from './pages/Agenda';
import SettingsPage from './pages/Settings';
import NotFound from './pages/NotFound';
import LoginPage from './pages/Login';
import { RequireAdmin, RequireAuth } from './components/RequireAuth';
import AppLayout from './components/AppLayout';

const App: React.FC = () => {
    const [theme, setTheme] = useState<string>(() => {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme) return savedTheme;
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    });

    useEffect(() => {
        if (theme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
    }, []);

    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path="/login" element={<LoginPage />} />

                <Route element={<RequireAuth />}> 
                  <Route element={<AppLayout theme={theme} toggleTheme={toggleTheme} />}> 
                    <Route index element={<Dashboard theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="map" element={<MapPage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="artists" element={<ArtistsPage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="artists/:id" element={<ArtistProfilePage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="analytics" element={<AnalyticsPage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="agenda" element={<AgendaPage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="workflow" element={<WorkflowPage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="partnerships" element={<PartnershipsPage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route path="settings" element={<SettingsPage theme={theme} toggleTheme={toggleTheme} />} />
                    <Route element={<RequireAdmin />}> 
                      <Route path="admin" element={<Admin theme={theme} toggleTheme={toggleTheme} />} />
                    </Route>
                    <Route path="*" element={<NotFound theme={theme} toggleTheme={toggleTheme} />} />
                  </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default App;
